import { render, staticRenderFns } from "./v-cell.vue?vue&type=template&id=2f1b93f2&scoped=true&"
var script = {}
import style0 from "./v-cell.vue?vue&type=style&index=0&id=2f1b93f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b93f2",
  null
  
)

export default component.exports